module.exports = __webpack_public_path__ + "static/media/bateau.1f025575.png";